
import $ from 'jquery';
import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupScrollPlugin from '@swup/scroll-plugin';
import Splide from '@splidejs/splide';
import AOS from 'aos';

const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

const $d = $(document),
      $w = $(window);

var rotation = 0;
var scrolled = false;


let mouseX, mouseY;

      
const swup = new Swup({
  plugins: [
    new SwupBodyClassPlugin(),
    new SwupScrollPlugin({
      doScrollingRightAway: false,
      animateScroll: true,
      scrollFriction: 0.3,
      scrollAcceleration: 0.04,
    })
  ]
}); 


// Events
swup.on('contentReplaced', init);
$d.on('mouseenter', '[data-graduate]', imagerOn);
$d.on('mouseleave', '[data-graduate]', imagerOff);
// $d.on('mousemove', mouseUpdate);

$d.on('click', '.carousel__thumbs .unit', carouselChange);
$d.on('click', '.nav__mobile', navToggle);



document.addEventListener("DOMContentLoaded", () => {
  // l('ready');
  // checkCookie();

  init();
});

// Functions 
function l(m) { 
  console.log(m); 
}

function init() {
  // l('👍');
  cookieNotice();
  lazyImages();
  aosInit()
  swup.cache.empty();

  navCheck();
  $('.nav').removeClass('nav--show');

  $('.nav__course').html('').attr('class', 'nav__course');
  $('.nav__graduate').html('').attr('class', 'nav__graduate');

  $('.unit').each(function(index) {
    let elem = $(this);
    addDots(elem);
  });

  flickerIn()

  $('.carousel').each(function(index) {
    carouselInit($(this))
  });
}

function aosInit() {
  AOS.init({
    duration: 450,
    once: false,
  });
}


function mouseUpdate(e) {
  mouseX = e.clienX;
  mouseX = e.clientY;
  console.log(mouseX, mouseX);
}


// let unit = '<div class="unit"></div>';


// function addUnit() {

//   $('.wall').prepend(unit)

// }


function lazyImages() {
  var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
  if ("IntersectionObserver" in window) {
    let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          let lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
          // lazyImage.srcset = lazyImage.dataset.srcset;
          lazyImage.classList.add("animate");
          lazyImageObserver.unobserve(lazyImage);
          
        }
      });
    });

    lazyImages.forEach(function (lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  }
}

function cookieNotice() {
  document.querySelector('.cookie_btn').addEventListener('click', setCookie);
}

function setCookie() {
  l('set cookie');
  document.cookie = 'cookie-note=1;max-age=864000';
  document.querySelector('.cookie').classList.add('hidden');
}



function addDots(elem) {

  for (let index = 0; index < 4; index++) {
    elem.append('<div class="hole"></div>');
  }
  
}

function imagerOn() {

  // get mouse location

  // l('imager on');
  // $('body').addClass('image-on')

  let img_class= $(this).data('class');

  let img_src = $(this).data('imager');
  let graduate = $(this).data('namer');
  let course = $(this).data('courser');
  let course_color = $(this).data('course-color');
 
  if (course !== undefined) {
    $('.nav__bottom').css('--color', course_color)
    $('.nav__course').addClass('show');
    $('.nav__course').html(course);

  }

  // l(graduate);
  if (graduate !== undefined) {
    $('.nav__graduate').addClass('show');
    $('.nav__graduate').html(graduate);
  }

  // $('.nav__course').addClass(course_color);

  let img = $('<img />', { 
    class: img_class,
    src: img_src
  });
  // img.appendTo($('.viewer'));

  
}

function imagerOff() {
  // l('imager off')
  // $('body').removeClass('image-on')


  $('.nav__course').html('').attr('class', 'nav__course');
  $('.nav__graduate').html('').attr('class', 'nav__graduate');

  $('.viewer img').remove();
}

let speed = 0;

function flickerIn() {

  if($('body').hasClass('all')){
    speed = 20;
  } else {
    speed = 50;
  }

  let elems = $('.unit');
  let count = elems.length;



  elems.each(function(index){
      $(this).delay(speed*index).queue(function() { $(this).addClass('unit--in').dequeue(); });
      count = count - 1; 
  

      if (count == 0) { 
      
      
        setTimeout(function() { 
          $('.wall').addClass('loaded')
          l('done')
        }, 4000);

      };

      

  })



}



function navCheck() {
  $('.nav a').removeClass('active');
  let active = '.' + $('main').data('nav');
  $('.nav ' + active).addClass('active');
}


function carouselInit(elem) {

  let first_img = elem.find('.carousel__thumbs .unit:first-of-type').data('imager');
  let first_caption = elem.find('.carousel__thumbs .unit:first-of-type').data('caption');
  let caption_wrap = elem.find('.unit--caption');
  let image_wrap = elem.find('.carousel__image');
  
  caption_wrap.html(first_caption);


  let img = $('<img />', { 
    class: '',
    src: first_img
  });
  img.appendTo(image_wrap);
  image_wrap.addClass('visible');


}


function carouselChange() {
  // hover of thumb get carousel parent

  l('carousel')


  let elem = $(this).closest('.carousel');

  let img_src = $(this).data('imager');
  let caption = $(this).data('caption');
  

  let caption_wrap = elem.find('.unit--caption');
  let image_wrap = elem.find('.carousel__image');
  
  image_wrap.removeClass('visible');
  image_wrap.find('img').remove();

  caption_wrap.html(caption);


  let img = $('<img />', { 
    class: '',
    src: img_src
  });
  img.appendTo(image_wrap);
  image_wrap.addClass('visible');

}



function  navToggle() {
  $('.nav').toggleClass('nav--show')
}









var favicon_images = [
  '/assets/images/frame1-favicon.jpeg',
  '/assets/images/frame2-favicon.jpeg',
  '/assets/images/frame3-favicon.jpeg',
  '/assets/images/frame4-favicon.jpeg',
  '/assets/images/frame5-favicon.jpeg',
  '/assets/images/frame6-favicon.jpeg',

],
image_counter = 0; // To keep track of the current image

setInterval(function() {
// remove current favicon
if(document.querySelector("link[rel='icon']") !== null)
document.querySelector("link[rel='icon']").remove();
if(document.querySelector("link[rel='shortcut icon']") !== null)
document.querySelector("link[rel='shortcut icon']").remove();

// add new favicon image
document.querySelector("head").insertAdjacentHTML('beforeend', '<link rel="icon" href="' + favicon_images[image_counter] + '" type="image/gif">');

// If last image then goto first image
// Else go to next image    
if(image_counter == favicon_images.length -1)
image_counter = 0;
else
image_counter++;
}, 1000);

